import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { ToastContainer, toast } from "react-toastify";
import "sweetalert2/src/sweetalert2.scss";
import moment from "moment";


//import filter modal
import FilterModal from "../../components/Modal/FilterModal.js";

import {
  getRequest,
  postRequest,
  deleteRequest,
  putRequest,
  putRequestForm,
  postRequestForm,
} from "../../components/Common/Utils.js";

import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator";
import axios from "axios";

import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Spinner,
  Badge,
  UncontrolledTooltip,
  Modal,
  Button,
} from "reactstrap";
import React, { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import ReactPaginate from "react-paginate";


const filterObj = {
  venueName: "",
  userName: "",
  title: "",
  stars: "",
  review: "",
  reply: "",
  status: "",
  createdAt: "",
};

const OrderDeliveryTable = ({ userId }) => {
  const [modal_center, setmodal_center] = useState(false);
  const [Productdata, setProductdata] = useState([]);
  const [loader, setLoader] = useState(false);
  const [searchText, setSearchText] = useState("");

  const [value, setValue] = React.useState(10);

  const [sort, setsort] = React.useState("");
  const [sortOrder, setsortOrder] = React.useState("desc");


  const [currentFPage, setCurrentFPage] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(0);
  const [sizePerPageOrg, setSizePerPage] = useState(10);
  const [image, setImage] = React.useState("");
  const [openLightbox, setOpenLightBox] = React.useState(false);
  const [model, setModel] = useState(false);
  const [filter, setFilter] = useState({ ...filterObj });

  const [loader2, setLoader2] = useState(false);

  const GetValueOnChange = async (value, _id) => {
    let actId = _id;
    let status = value == 1 ? 1 : 0;

    const formData = new FormData();
    formData.append("ProductId", actId);
    formData.append("isPublished", status);

    const res = await postRequest("update-by-admin", formData);

    if (res.status) {
      toast.success("Product Status updated Successfully");
      fetchOrderDelivery();
    } else {
      toast.error("Something went wrong");
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchOrderDelivery();
  }, [currentPage]);

  useEffect(() => {
    fetchOrderDelivery();
  }, [sizePerPageOrg, sort, sortOrder]);

  const closeModal = () => {
    setModel(false);
  };

  const toggleModel = () => {
    console.log("toggleModel", model);
    setModel(!model);
  };


  const handleTableChange = (type, { page, sizePerPage, searchText }) => {
    if (type === "pagination") {
      if (page != currentPage) {
        setCurrentPage(page);
        console.log("page", page);
      }
    }

    console.log("type", type);

    if (type === "search") {
      console.log("searchText", searchText);
    }
  };

  function removeBodyCss() {
    document.body.classList.add("no_padding");
  }

  const updateFilter = (key, value) => {
    const filterObj = { ...filter };
    filterObj[key] = value;
    setFilter(filterObj);
  };

  const applyFilter = () => {
    const filterArgs = [];

    Object.keys(filter).forEach((key) => {
      if (
        filter[key] !== "" &&
        filter[key] !== null &&
        filter[key] !== undefined
      ) {


        var filterObject = {
          [key]: filter[key],
        };


        if (key === "venueName" || key === "userName" || key === "review" || key === "reply") {
          filterObject.type = "regex";
        } else if (key === "status" || key === "stars") {
          filterObject.type = "eq";
        } else if (key === "createdAt") {
          filterObject.type = "date-eq";
        }

        filterArgs.push(filterObject);
      }
    });

    console.log("filterArgs", filterArgs);
    toggleModel();
    fetchOrderDelivery(filterArgs);
  };

  const resetFilter = () => {
    setFilter({ ...filterObj });
    toggleModel();
    fetchOrderDelivery();
  };

  const defaultSorted = [
    {
      dataField: "_id",
      order: "asc",
    },
  ];

  function tog_center() {
    setmodal_center(!modal_center);
    removeBodyCss();
  }

  function activeFormatter(cellContent, row) {
    return (
      <>
        {row.isPublished ? (
          <>
            <button
              className="btn btn-active"
              type="button"
              onClick={() => GetValueOnChange((row.isPublished = false), row._id)}
            >
              Active
            </button>
          </>
        ) : (
          <>
            <button
              className="btn btn-deactive"
              type="button"
              onClick={() => GetValueOnChange((row.isPublished = true), row._id)}
            >
              Inactive
            </button>
          </>
        )}
      </>
    );
  }

  function createdAtdata(cellContent, row) {
    return (
      <React.Fragment>
        <div>
          <p>{moment(row.createdAt).format("DD-MM-YYYY")} </p>
        </div>
      </React.Fragment>
    );
  }


  function SNoFormatter(cellContent, row, i) {
    return <>{i + 1}</>;
  }



  function PaymentStatusFormatter(cellContent, row) {
    return (
      <>
        {row?.orderType == "User" &&
          <span className="status-bg-span" style={{
            textTransform: 'capitalize',
            fontWeight: 'bold',
            color: row?.paymentStatus === 'completed' || row?.paymentStatus === 'Paid'
              ? '#4caf50'
              : row?.paymentStatus === 'Cancelled'
                ? '#ec536c'
                : '#FFC107'
          }}>
            {row?.paymentStatus}
          </span>}
        {row?.orderType == "Manufacturer" &&
          <span className="status-bg-span" style={{
            textTransform: 'capitalize',
            fontWeight: 'bold',
            color: row?.adminPayStatus === 'completed' || row?.adminPayStatus === 'Paid'
              ? '#4caf50'
              : row?.adminPayStatus === 'Cancelled'
                ? '#ec536c'
                : '#FFC107'
          }}>
            {row?.adminPayStatus}
          </span>}
      </>
    );
  }
  function PaymentMethodFormatter(cellContent, row) {
    return (
      <>
        <span>
          {row?.paymentMethod}
        </span>
      </>
    );
  }
  function TotalPaymentFormatter(cellContent, row) {
    return (
      <>
        ${row?.totalAmount}
      </>
    );
  }

  function iconFormatter2(cellContent, row) {
    const getPath = () => {
      if (row?.orderType === "User") {
        return `/user-order-details/${row?._id}`;
      } else if (row?.orderType === "Manufacturer") {
        return `order-sent-manufacturer/${row?._id}`
      }
      return "#";
    };

    return (
      <div className="d-flex gap-2">
        <button type="button" className=" btn btn-primary">
          <Link
            to={{
              pathname: getPath(),
              state: { row },
            }}
          >
            <i className="fal fa-eye fs-5 text-light"></i>
          </Link>
        </button>

      </div>
    )
  }

  function OrderLinkFormatter(cellContent, row) {
    const getPath = () => {
      if (row?.orderType === "User") {
        return `/user-order-details/${row?._id}`;
      } else if (row?.orderType === "Manufacturer") {
        return `order-sent-manufacturer/${row?._id}`
      }
      return "#";
    };

    return (
      <div className="d-flex gap-2">
        <Link
          to={{
            pathname: getPath(),
            state: { row },
          }}>
          {row?._id}
        </Link>
      </div>
    );
  }

  function OrderStatusFormatter(cellContent, row) {
    return (
      <>
        <span className="status-bg-span" style={{
          textTransform: 'capitalize',
          fontWeight: 'bold',
          color:
            row?.orderStatus === 'pending'
              ? '#FFC107'
              : row?.orderStatus === 'cancelled'
                ? '#ec536c'
                : '#4caf50',
        }}>
          {row?.orderStatus}
        </span>
      </>
    );
  }

  function DeliveryStatusFormatter(cellContent, row) {
    return (
      <p className="mb-0" style={{ textTransform: 'capitalize', fontWeight: 'bold' }}>
        <span className="status-bg-span"
          style={
            row?.deliveryStatus === "cancelled"
              ? { color: "#ec536c" }
              : row?.deliveryStatus === "failed"
                ? { color: "#ec536c" }
                : row?.deliveryStatus === "pending"
                  ? { color: "#ec536c" }
                  : row?.deliveryStatus === "assigned"
                    ? { color: "rgb(255, 193, 7)" }
                    : { color: "#4caf50" }
          }
        >{row?.deliveryStatus} </span>
      </p>
    );
  }

  const components = [
    <div className="row mb-4" key="title">
      <label className="col-sm-3 col-form-label">Venue</label>
      <div className="col-sm-6">
        <input
          type="text"
          value={filter.venueName}
          onChange={(e) => updateFilter("venueName", e.target.value)}
          name="venue"
          className="form-control"
        />
      </div>
    </div>,

    <div className="row mb-4" key="amount">
      <label className="col-sm-3 col-form-label">User</label>
      <div className="col-sm-6">
        <input
          type="text"
          value={filter.userName}
          onChange={(e) => updateFilter("userName", e.target.value)}
          name="user"
          className="form-control"
        />
      </div>
    </div>,

    <div className="row mb-4" key="title">
      <label className="col-sm-3 col-form-label">Title</label>
      <div className="col-sm-6">
        <input
          type="text"
          value={filter.title}
          onChange={(e) => updateFilter("title", e.target.value)}
          name="title"
          className="form-control"
        />
      </div>
    </div>,

    <div className="row mb-4" key="title">
      <label className="col-sm-3 col-form-label">Stars</label>
      <div className="col-sm-6">
        <input
          type="text"
          value={filter.stars}
          onChange={(e) => updateFilter("stars", e.target.value)}
          name="stars"
          className="form-control"
        />
      </div>
    </div>,
    <div className="row mb-4" key="title">
      <label className="col-sm-3 col-form-label">Review</label>
      <div className="col-sm-6">
        <input
          type="text"
          value={filter.review}
          onChange={(e) => updateFilter("review", e.target.value)}
          name="review"
          className="form-control"
        />
      </div>
    </div>,
    <div className="row mb-4" key="title">
      <label className="col-sm-3 col-form-label">Reply</label>
      <div className="col-sm-6">
        <input
          type="text"
          value={filter.reply}
          onChange={(e) => updateFilter("reply", e.target.value)}
          name="reply"
          className="form-control"
        />
      </div>
    </div>,

    <div className="row mb-4" key="title">
      <label className="col-sm-3 col-form-label">Status</label>
      <div className="col-sm-6">
        <select
          onChange={(e) => updateFilter("status", e.target.value)}
          className="form-select"
        >
          <option value="">Select Status</option>
          <option value="true">Active</option>
          <option value="false">Inactive</option>
        </select>
      </div>
    </div>,

    <div className="row mb-4" key="title">
      <label className="col-sm-3 col-form-label">Created Date</label>
      <div className="col-sm-6">
        <input
          type="date"
          value={filter.createdAt}
          onChange={(e) => updateFilter("createdAt", e.target.value)}
          name="createdAt"
          className="form-control"
        />
      </div>
    </div>,

    // submit button

    <div className="mt-5 mt-lg-4" key="submit">
      <div className="row justify-content-end">
        <div className="col-sm-9">
          <div>
            <button
              type="button"
              onClick={applyFilter}
              className="btn btn-primary w-md"
            >
              Filter
            </button>
            <button
              onClick={resetFilter}
              type="button"
              className="btn btn-danger w-md mx-4"
            >
              Reset
            </button>
          </div>
        </div>
      </div>
    </div>,
  ];

  const columns = [
    {
      text: "S.NO",
      formatter: SNoFormatter,
      sort: false,
    },
    {

      //text: "Order Id",
      dataField: "_id",
      formatter: OrderLinkFormatter,
      sort: false,
    },
    {
      dataField: "orderType",
      text: "Orer Type",
      sort: false,
      // formatter: OrderStatusFormatter,
    },
    {
      // dataField: "orderStatus",
      text: "Order Status",
      sort: false,
      formatter: OrderStatusFormatter,
    },
    {
      // dataField: "deliveryStatus",
      text: "Delivery Status",
      sort: false,
      formatter: DeliveryStatusFormatter,
    },
    {
      // dataField: "paymentStatus",
      text: "Payment Status",
      sort: false,
      formatter: PaymentStatusFormatter,
    },
    // {
    //   // dataField: "paymentStatus",
    //   text: "Payment Method",
    //   sort: false,
    //   formatter: PaymentMethodFormatter,
    // },

    {
      // dataField: "totalAmount",
      text: "Total Amount",
      formatter: TotalPaymentFormatter,
      sort: false,
    },
    {
      // dataField: "totalAmount",
      text: "Actions",
      formatter: iconFormatter2,
      sort: false,
    },
  ];

  function userFormatter(cellContent, row) {
    return (
      <div style={{ display: 'flex', gap: '10px' }}>
        <img
          src={row.userImage}
          onClick={() => showLightBox(row.userImage)}
          alt="Image"
          width={"50px"}
          style={{ borderRadius: '20%' }} // This makes the image round
        />
        <p>{row.userName}</p>
      </div>
    );
  }

  function hotelFormatter(cellContent, row) {
    return (
      <div style={{ display: 'flex', gap: '10px' }}>
        {/* <img
        src={row?.type == 'hotel' ?  row?.hotelData?.image[1]?.fileName : row?.type == 'transfer' ? row?.transferData?.image[1]?.fileName : row?.type == 'ticket' ? `https://ui-avatars.com/api/?background=random&name=${row?.ticketData?.name}` : '' }
        onClick={() => showLightBox(row?.type == 'hotel' ?  row?.hotelData?.image[0]?.fileName : row?.type == 'transfer' ? row?.transferData?.image[0]?.fileName : row?.type == 'ticket' ? `https://ui-avatars.com/api/?background=random&name=${row?.ticketData?.name}` : '')}
        alt="Image"
        width={"50px"}
        style={{ borderRadius: '20%' }} // This makes the image round
      /> */}
        <p>{row?.type == 'hotel' ? row?.hotelData?.name : row?.type == 'ticket' ? row?.ticketData?.name : row?.transferData?.name}</p>
      </div>
    );
  }

  const handleChange = (event) => {
    setSizePerPage(event.target.value);
  };
  const handlesorting = (event) => {
    setsort(event.target.value);
  };
  const handlesortOrder = (event) => {
    setsortOrder(event.target.value);
  };
  const handleReload = () => {
    setSearchText(" ");
    fetchOrderDelivery();
  };

  function iconFormatter(cellContent, row) {
    return (
      <React.Fragment>
        <div className="d-flex">
          <button type="button" className=" btn btn-info  mx-2">
            {" "}
            <Link
              to={{
                pathname: `/product-details`,
                state: { row },
              }}
            >
              {" "}
              <i class="fal fa-eye text-light"></i>
            </Link>{" "}
          </button>
          {/* <button type="button" className=" btn btn-info  mx-2">
            {" "}
            <Link
              to={{
                pathname: `/addReply/${row._id}`,
                state: { row },
              }}
            >
              {" "}
              <i class="fal fa-reply fs-5 text-light"></i>
            </Link>{" "}
          </button>
          <button
            type="button"
            className="btn btn-danger"
            onClick={() => handlerdelete(row._id)}
          >
            <i class="fal fa-trash  fs-5"></i>
          </button> */}
          &nbsp;&nbsp;
        </div>
      </React.Fragment>
    );
  }

  const fetchOrderDelivery = async (filterArgs = [{ type: "objectId" }]) => {
    try {
      setLoader(true);
      const payload = {
        limit: sizePerPageOrg,
        page: currentPage,
        sortField: sort,
        sortOrder: sortOrder,
        deliveryAgentId: userId,
        search: searchText,
      };
      if (Array.isArray(filterArgs) && filterArgs?.length) {
        payload.filterArgs = filterArgs;
      } else if (searchText) {
        payload.search = searchText;
      }
      // Make API request
      const response = await postRequest('delivery-Agent/admin/delivery-Agent-order-list', payload);
      // Handle response data
      if (response?.status) {
        const data = response?.data || [];
        setTotalPage(data?.count);
        setProductdata(data?.list);
        setCurrentFPage(data?.page);
        // Reset search text
        setSearchText('');
      }
    } catch (error) {
      console.error('Error fetching product list:', error);
      // Optionally display error feedback to the user
    } finally {
      setLoader(false);
    }
  };


  const handlerdelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const response = await deleteRequest(`Product/update`, { ProductId: id });
        if (response.status) {
          Swal.fire("Deleted!", "Deleted successfully");
          fetchOrderDelivery();
        } else {
          Swal.fire("Error!", "Something went wrong");
        }
      }
    });
  };


  return (
    <>
      <React.Fragment>
        <ToastContainer />
        <Row>
          {/* <Col className="12">
            <div className="page-title-box">
              <h4>Hotel Product Management</h4>

              <ol className="breadcrumb m-0">
                <li className="breadcrumb-item active">Product Management</li>:{" "}
                <li className="breadcrumb-item">Product List</li>
              </ol>
            </div>
          </Col> */}

          <Col className="col-12">
            <Card>
              {loader ? (
                <CardBody style={{ height: "100px" }}>
                  <Spinner
                    color="info"
                    style={{
                      height: "4rem",
                      width: "4rem",
                      position: "absolute",
                      left: "50%",
                    }}
                  >
                    Loading...
                  </Spinner>
                </CardBody>
              ) : (
                <CardBody className="table-shorting">
                  {
                    <PaginationProvider
                      pagination={paginationFactory({
                        page: currentFPage,
                        sizePerPage: sizePerPageOrg,
                        totalSize: totalPage,
                        custom: true,
                      })}
                    >
                      {({ paginationProps, paginationTableProps }) => (
                        <>
                          <ToolkitProvider
                            keyField="_id"
                            data={Productdata}
                            columns={columns}
                          >
                            {(props) => (
                              <Row>
                                <Col className="col-lg-12 d-flex mb-3">
                                  <label className="mb-0 text-label">
                                    Page Size
                                  </label>
                                  <select
                                    value={sizePerPageOrg}
                                    onChange={handleChange}
                                    className="form-select"
                                    style={{ width: "7%" }}
                                  >
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="50">50</option>
                                  </select>

                                  <label className="mb-0 text-label ms-3">
                                    Sort By:
                                  </label>
                                  <select
                                    value={sort}
                                    onChange={handlesorting}
                                    className="form-select"
                                    style={{ width: "10%" }}
                                  >
                                    <option value="orderStatus">
                                      {" "}
                                      Order Status
                                    </option>


                                    <option value="deliveryStatus">Delivery Status</option>
                                    <option value="paymentStatus">Payment Status</option>


                                  </select>
                                  <label className="mb-0 text-label ms-3">
                                    Sort Order:
                                  </label>
                                  <select
                                    value={sortOrder}
                                    onChange={handlesortOrder}
                                    className="form-select"
                                    style={{ width: "10%" }}
                                  >
                                    <option value="asc"> Ascending</option>
                                    <option value="desc">Descending</option>

                                  </select>
                                  <div className="filter-item">
                                    <input
                                      type="search"
                                      placeholder="Search"
                                      value={searchText}
                                      class="form-control"
                                      onChange={(e) =>
                                        setSearchText(e.target.value)
                                      }
                                      style={{ width: "30%" }}
                                    />
                                    <button
                                      onClick={() => {
                                        fetchOrderDelivery();
                                      }}
                                      type="button"
                                      className="btn btn-primary mx-2"
                                    >
                                      Search
                                    </button>
                                    <button
                                      type="button"
                                      onClick={handleReload}
                                      className="btn btn-danger mx-2"
                                    >
                                      Reset
                                    </button>

                                    {/* <button
                                      type="button"
                                      onClick={toggleModel}
                                      className="btn btn-info"
                                    >
                                      Filter
                                    </button> */}
                                  </div>
                                </Col>

                                <Col className="col-lg-12 text-end">
                                  <BootstrapTable
                                    onTableChange={handleTableChange}
                                    remote={true}
                                    classes="table-striped"
                                    {...props.baseProps}
                                    {...paginationTableProps}
                                  />
                                </Col>
                              </Row>
                            )}
                          </ToolkitProvider>

                          <Row>
                            <Col className="col-lg-12 text-end">
                              <div className="text-md-right">
                                <PaginationListStandalone
                                  {...paginationProps}
                                />
                              </div>
                            </Col>
                          </Row>
                        </>
                      )}
                    </PaginationProvider>
                  }
                </CardBody>
              )}
            </Card>
          </Col>
        </Row>

      </React.Fragment>
      <FilterModal
        show={model}
        closeModal={closeModal}
        components={components}
      />
    </>
  );
};

export default OrderDeliveryTable;
